// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__3_Xhx","path":"style_path__ZxYOq","arrow":"style_arrow__29Rki"};